import { getLogger } from "@expert/logging";
import ky from "ky";
import { createAuthorizationBearerHook, createErrorLoggingHook, userCache } from "@/shared-utils/auth";
import { env } from "./environment";

export const getTrainingSessionApiClient = () => {
    return ky.create({
        prefixUrl: env.trainingSessionBaseUrl,
        timeout: 30_000,
        hooks: {
            beforeRequest: [createAuthorizationBearerHook(() => userCache.ssoAccessToken)],
            beforeError: [createErrorLoggingHook(getLogger({ module: "api" }))],
        },
    });
};
